import { render, staticRenderFns } from "./billing-add-to-grid.vue?vue&type=template&id=4fa883f5&scoped=true&"
import script from "./billing-add-to-grid.ts?vue&type=script&lang=ts&"
export * from "./billing-add-to-grid.ts?vue&type=script&lang=ts&"
import style0 from "./billing-add-to-grid.scss?vue&type=style&index=0&id=4fa883f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa883f5",
  null
  
)

export default component.exports